import RcCheckbox, { CheckboxProps, CheckboxRef } from "rc-checkbox";
import { useRef } from "react";
import "./index.css";
export interface ICheckboxProps extends CheckboxProps {
  wrapperClassName?: string;
  contentClassName?: string;
}

const Checkbox: React.FC<ICheckboxProps> = ({ children, ...props }) => {
  const { wrapperClassName, contentClassName } = props;

  const checkBoxRef = useRef<CheckboxRef>(null);
  const getRcCheckboxProps = () => {
    const rcCheckboxProps = { ...props };
    delete rcCheckboxProps.wrapperClassName;
    delete rcCheckboxProps.contentClassName;
    return rcCheckboxProps;
  };
  return (
    <div className={`flex gap-2 items-center select-none ${wrapperClassName}`}>
      <RcCheckbox ref={checkBoxRef} {...getRcCheckboxProps()}></RcCheckbox>
      <div
        className={`text-3.5 text-mx-secondary cursor-pointer ${contentClassName}`}
        onClick={() => {
          checkBoxRef.current?.input?.click();
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default Checkbox;
